import styled from 'styled-components';

import {
  Container as RawContainer,
  size,
  mediaQueries,
} from '@everlywell/leaves';

const Container = styled(RawContainer)`
  padding-top: ${size.xl2}px;

  ${mediaQueries.forTabletHorizontalUp} {
    padding-top: ${size.xl6}px;
  }
`;

export default Container;
